const checkUserHasAccount = (userData) => {
  return userData && userData.user_account_info && Object.keys(userData.user_account_info).length > 0
}

const checkUserHasPremiumAccess = (userData) => Boolean(
  userData?.has_premium_access ||
    userData?.has_active_subscription ||
    userData?.max_trial_active
)

const checkUserHasSubscription = (userData) => {
  return checkUserHasAccount(userData) && checkUserHasPremiumAccess(userData)
}

const checkUserHasMaxAccess = (userData) => Boolean(
  userData?.is_admin_user ||
    userData?.max_trial_active ||
    (
      checkUserHasPremiumAccess(userData) &&
      userData?.subscription_plan_tier === "max"
    )
)

export {
  checkUserHasAccount,
  checkUserHasMaxAccess,
  checkUserHasPremiumAccess,
  checkUserHasSubscription,
}
